/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Empty_TranscriptInputs */



/**
* | output |
* | --- |
* | "Sent captions will appear here." |
*
* @param {Live_Caption_Empty_TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_empty_transcript = /** @type {((inputs?: Live_Caption_Empty_TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Empty_TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les légendes envoyées apparaîtront ici.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die gesendeten Untertitel werden hier angezeigt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le didascalie inviate appariranno qui.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Присланные субтитры появятся здесь.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los subtítulos enviados aparecerán aquí.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发送的字幕将显示在此处。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("送信された字幕はここに表示されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भेजे गए कैप्शन यहां दिखाई देंगे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As legendas enviadas aparecerão aqui.")
	return /** @type {LocalizedString} */ ("Sent captions will appear here.")
});